<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Formulário IVCF-20"
    >
        <rkm-form
            v-if="!!model"
            ref="RkmForm"
        >
            <rkm-row>
                <rkm-col>
                    <p>
                        As perguntas são direcionadas à pessoa idosa e, quando possível, devem ser confirmadas pelo familiar ou acompanhante, desde
                        que convivam com a pessoa idosa e estejam em condições de responder aos questionamentos. Nas pessoas idosas incapazes de
                        responder, utilizar as respostas do cuidador.
                    </p>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-alert>Em geral o tempo de aplicação deste instrumento varia de 5 a 10 minutos.</rkm-alert>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        @change="handleDesejaPreencherChange"
                        label="Deseja preencher o IVCF 20 para esta pessoa?"
                        v-model="model.desejaPreencher"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Nao</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <template v-if="model.desejaPreencher">
                <rkm-row>
                    <rkm-col>
                        <h5>Perguntas do instrumento</h5>
                    </rkm-col>
                </rkm-row>

                <rkm-area title="Idade do cidadão | Grupo 1 de 8">
                    <rkm-form-input
                        :value="data.form.paciente.idade"
                        name="pacienteIdade"
                        readonly
                    />
                </rkm-area>

                <rkm-area no-margin-top title="Percepção da saúde | Grupo 2 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.estadoSaudeGeral"
                                label="Em geral, comparando com outras pessoas de sua idade, você diria que sua saúde é"
                                v-model="model.estadoSaudeGeral"
                            >
                                <rkm-form-radio value="excelente_muito_boa_ou_boa">Excelente, muito boa ou boa</rkm-form-radio>
                                <rkm-form-radio value="regular_ou_ruim">Regular ou ruim</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Atividades de vida diária | Grupo 3 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Atividades de vida diária instrumental</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <p>Por causa de sua saúde ou condição física,</p>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoCompras"
                                label="Você deixou de fazer compras?"
                                v-model="model.limitacaoCompras"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não faz compras por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoGestaoFinanceira"
                                label="Você deixou de controlar seu dinheiro, gastos ou pagar as contas de sua casa?"
                                v-model="model.limitacaoGestaoFinanceira"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não controla o dinheiro por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoTarefasDomesticas"
                                label="Você deixou de realizar pequenos trabalhos domésticos, como lavar a louça, arrumar a casa ou fazer limpeza leve?"
                                v-model="model.limitacaoTarefasDomesticas"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não ou não faz mais pequenos trabalhos domésticos por outros motivos que não a saúde</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Atividades de vida diária básica</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.banhoIndependencia"
                                label="Por causa de sua saúde ou condição física, você deixou de tomar banho sozinho?"
                                v-model="model.banhoIndependencia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Cognição | Grupo 4 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.relatoEsquecimentoPorTerceiros"
                                label="Algum familiar ou amigo falou que você está ficando esquecido?"
                                v-model="model.relatoEsquecimentoPorTerceiros"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.esquecimentoPiorando"
                                label="Você tem um esquecimento que está piorando nos últimos meses?"
                                v-model="model.esquecimentoPiorando"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.esquecimentoImpactaAtividades"
                                label="Você tem um esquecimento que está impedindo a realização de alguma atividade do cotidiano?"
                                v-model="model.esquecimentoImpactaAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Humor | Grupo 5 de 8">
                    <rkm-row>
                        <rkm-col>
                            <p>No último mês,</p>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.humorTristezaDesanimo"
                                label="Você ficou com desânimo, tristeza ou desesperança?"
                                v-model="model.humorTristezaDesanimo"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.perdaInteresseAtividades"
                                label="Você perdeu o interesse ou prazer em atividades anteriormente prazerosas?"
                                v-model="model.perdaInteresseAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Mobilidade | Grupo 6 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Alcance, preensão e pinça</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoElevarBracos"
                                label="Você é incapaz de elevar os braços acima do nível do ombro?"
                                v-model="model.limitacaoElevarBracos"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.limitacaoMotricidadeFina"
                                label="Você é incapaz de manusear ou segurar pequenos objetos?"
                                v-model="model.limitacaoMotricidadeFina"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Capacidade aeróbica e/ou muscular</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.perdaPesoNaoIntencional"
                                label="Você teve perda de peso não intencional de 4,5 kg ou 5% do peso corporal no último ano, 6 kg nos últimos 6 meses ou 3 kg no último mês?"
                                v-model="model.perdaPesoNaoIntencional"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.imcAbaixo22"
                                label="Você tem Índice de Massa Corporal (IMC) menor que 22 kg/m²?"
                                v-model="model.imcAbaixo22"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.panturrilhaAbaixo31"
                                label="Você tem a circunferência (perímetro) da panturrilha menor que 31 centímetros?"
                                v-model="model.panturrilhaAbaixo31"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.marchaLenta4mMaior5s"
                                label="Em um teste de velocidade da marcha, o tempo gasto pela pessoa idosa para percorrer 4 metros é maior do que 5 segundos?"
                                v-model="model.marchaLenta4mMaior5s"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Marcha</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.dificuldadeCaminharImpactoAtividades"
                                label="Você tem dificuldade para caminhar que possa impedir a realização de alguma atividade do cotidiano?"
                                v-model="model.dificuldadeCaminharImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.quedasRecorrentes"
                                label="Você teve duas ou mais quedas no último ano?"
                                v-model="model.quedasRecorrentes"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Continência esfincteriana</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.incontinencia"
                                label="Você perde urina ou fezes, sem querer, em algum momento?"
                                v-model="model.incontinencia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Comunicação | Grupo 7 de 8">
                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Visão</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.problemaVisaoImpactoAtividades"
                                label="Você tem problemas de visão capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de óculos ou lentes de contato)"
                                v-model="model.problemaVisaoImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <strong class="text-info">Audição</strong>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.problemaAudicaoImpactoAtividades"
                                label="Você tem problemas de audição capazes de impedir a realização de alguma atividade do cotidiano? (É permitido o uso de aparelhos de audição)"
                                v-model="model.problemaAudicaoImpactoAtividades"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-area no-margin-top title="Comorbidade múltipla | Grupo 8 de 8">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.doencasCronicasMultiplas"
                                label="Você tem cinco ou mais doenças crônicas?"
                                v-model="model.doencasCronicasMultiplas"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.polifarmacia5OuMaisMedicamentos"
                                label="Você faz uso regular de cinco ou mais medicamentos diferentes todos os dias?"
                                v-model="model.polifarmacia5OuMaisMedicamentos"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                :validations="validations.ivcf.internacaoUltimos6Meses"
                                label="Você teve alguma internação nos últimos 6 meses?"
                                v-model="model.internacaoUltimos6Meses"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <template v-if="pontuacaoIvcf > 0">
                    <rkm-area no-margin-top title="Pontuação final do IVCF 20">
                        <rkm-alert
                            v-if="pontuacaoIvcf <= 6"
                            color="success"
                        >
                            Idoso com BAIXO risco de vulnerabilidade Clínico-funcional – IDOSO ROBUSTO
                        </rkm-alert>

                        <rkm-alert
                            v-else-if="pontuacaoIvcf >= 7 && pontuacaoIvcf <= 14"
                            color="warning"
                        >
                            Idoso com MODERADO risco de vulnerabilidade Clínico-funcional – IDOSO EM RISCO DE FRAGILIZAÇÃO
                        </rkm-alert>

                        <rkm-alert
                            v-else-if="pontuacaoIvcf >= 15"
                            color="danger"
                        >
                            Idoso com ALTO risco de vulnerabilidade Clínico-funcional – IDOSO FRÁGIL
                        </rkm-alert>
                    </rkm-area>
                </template>
            </template>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="store"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import { error, object } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                ivcf: {
                    estadoSaudeGeral: { required: true },
                    limitacaoCompras: { required: true },
                    limitacaoGestaoFinanceira: { required: true },
                    limitacaoTarefasDomesticas: { required: true },
                    banhoIndependencia: { required: true },
                    relatoEsquecimentoPorTerceiros: { required: true },
                    esquecimentoPiorando: { required: true },
                    esquecimentoImpactaAtividades: { required: true },
                    humorTristezaDesanimo: { required: true },
                    perdaInteresseAtividades: { required: true },
                    limitacaoElevarBracos: { required: true },
                    limitacaoMotricidadeFina: { required: true },
                    perdaPesoNaoIntencional: { required: true },
                    imcAbaixo22: { required: true },
                    panturrilhaAbaixo31: { required: true },
                    marchaLenta4mMaior5s: { required: true },
                    dificuldadeCaminharImpactoAtividades: { required: true },
                    quedasRecorrentes: { required: true },
                    incontinencia: { required: true },
                    problemaVisaoImpactoAtividades: { required: true },
                    problemaAudicaoImpactoAtividades: { required: true },
                    doencasCronicasMultiplas: { required: true },
                    polifarmacia5OuMaisMedicamentos: { required: true },
                    internacaoUltimos6Meses: { required: true },
                },
            }
        },
        pontuacaoIvcf() {
            let pontuacao = 0

            if (this.data.form.paciente.idadeAnos >= 75 && this.data.form.paciente.idadeAnos <= 84) {
                pontuacao += 1
            }
            else if (this.data.form.paciente.idadeAnos >= 85) {
                pontuacao += 3
            }

            if (this.model.estadoSaudeGeral === 'regular_ou_ruim') {
                pontuacao += 1
            }

            if (this.model.limitacaoCompras || this.model.limitacaoGestaoFinanceira || this.model.limitacaoTarefasDomesticas) {
                pontuacao += 4
            }

            if (this.model.banhoIndependencia) {
                pontuacao += 6
            }

            if (this.model.relatoEsquecimentoPorTerceiros) {
                pontuacao += 1
            }

            if (this.model.esquecimentoPiorando) {
                pontuacao += 1
            }

            if (this.model.esquecimentoImpactaAtividades) {
                pontuacao += 2
            }

            if (this.model.humorTristezaDesanimo) {
                pontuacao += 2
            }

            if (this.model.perdaInteresseAtividades) {
                pontuacao += 2
            }

            if (this.model.limitacaoElevarBracos) {
                pontuacao += 1
            }

            if (this.model.limitacaoMotricidadeFina) {
                pontuacao += 1
            }

            if (this.model.perdaPesoNaoIntencional || this.model.imcAbaixo22 || this.model.panturrilhaAbaixo31 || this.model.marchaLenta4mMaior5s) {
                pontuacao += 2
            }

            if (this.model.dificuldadeCaminharImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.quedasRecorrentes) {
                pontuacao += 2
            }

            if (this.model.incontinencia) {
                pontuacao += 2
            }

            if (this.model.problemaVisaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.problemaAudicaoImpactoAtividades) {
                pontuacao += 2
            }

            if (this.model.doencasCronicasMultiplas || this.model.polifarmacia5OuMaisMedicamentos || this.model.internacaoUltimos6Meses) {
                pontuacao += 4
            }

            return pontuacao
        },
    },
    data: () => ({
        item: null,
        model: null,
    }),
    methods: {
        open(item) {
            this.item = item

            this.model = this.clone(this.item)

            this.$refs.RkmModal.show()
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    Object.assign(this.item, this.model)

                    this.$refs.RkmModal.hide()
                })
        },
        reset() {
            this.model.desejaPreencher = false
            this.model.estadoSaudeGeral = null
            this.model.limitacaoCompras = null
            this.model.limitacaoGestaoFinanceira = null
            this.model.limitacaoTarefasDomesticas = null
            this.model.banhoIndependencia = null
            this.model.relatoEsquecimentoPorTerceiros = null
            this.model.esquecimentoPiorando = null
            this.model.esquecimentoImpactaAtividades = null
            this.model.humorTristezaDesanimo = null
            this.model.perdaInteresseAtividades = null
            this.model.limitacaoElevarBracos = null
            this.model.limitacaoMotricidadeFina = null
            this.model.perdaPesoNaoIntencional = null
            this.model.imcAbaixo22 = null
            this.model.panturrilhaAbaixo31 = null
            this.model.marchaLenta4mMaior5s = null
            this.model.dificuldadeCaminharImpactoAtividades = null
            this.model.quedasRecorrentes = null
            this.model.incontinencia = null
            this.model.problemaVisaoImpactoAtividades = null
            this.model.problemaAudicaoImpactoAtividades = null
            this.model.doencasCronicasMultiplas = null
            this.model.polifarmacia5OuMaisMedicamentos = null
            this.model.internacaoUltimos6Meses = null
        },
        handleDesejaPreencherChange(value) {
            if (value === false) {
                this.showConfirmation(
                    'Deseja realmente descartar os dados já preenchidos do IVFC 20?',
                    async () => {
                        this.model.estadoSaudeGeral = null
                        this.model.limitacaoCompras = null
                        this.model.limitacaoGestaoFinanceira = null
                        this.model.limitacaoTarefasDomesticas = null
                        this.model.banhoIndependencia = null
                        this.model.relatoEsquecimentoPorTerceiros = null
                        this.model.esquecimentoPiorando = null
                        this.model.esquecimentoImpactaAtividades = null
                        this.model.humorTristezaDesanimo = null
                        this.model.perdaInteresseAtividades = null
                        this.model.limitacaoElevarBracos = null
                        this.model.limitacaoMotricidadeFina = null
                        this.model.perdaPesoNaoIntencional = null
                        this.model.imcAbaixo22 = null
                        this.model.panturrilhaAbaixo31 = null
                        this.model.marchaLenta4mMaior5s = null
                        this.model.dificuldadeCaminharImpactoAtividades = null
                        this.model.quedasRecorrentes = null
                        this.model.incontinencia = null
                        this.model.problemaVisaoImpactoAtividades = null
                        this.model.problemaAudicaoImpactoAtividades = null
                        this.model.doencasCronicasMultiplas = null
                        this.model.polifarmacia5OuMaisMedicamentos = null
                        this.model.internacaoUltimos6Meses = null
                    },
                    async () => {
                        this.model.desejaPreencher = true
                    }
                )
            }
        },
    },
    mixins: [error, object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>